import { Link } from "react-router-dom";
import AppPageShell from "./AppPageShell";
import { LEGAL_OPERATOR, LEGAL_REVISION } from "../content/legalMeta";

export default function LegalDocumentPage({
  title,
  subtitle,
  heroLead,
  heroMeta,
  sections,
  footerLinks = [],
  footerNote,
  standalone = false,
}) {
  const metaItems = heroMeta ?? [
    `Редакция от ${LEGAL_REVISION}`,
    `Оператор: ${LEGAL_OPERATOR.status} ${LEGAL_OPERATOR.shortName}, ИНН ${LEGAL_OPERATOR.inn}`,
  ];

  const page = (
    <AppPageShell title={title} subtitle={subtitle} className="app-page--legal">
      <div className="app-rules-layout">
        <section className="app-rules-hero">
          <p className="app-rules-hero__lead">{heroLead}</p>
          <div className="app-rules-hero__meta">
            {metaItems.map((item) => (
              <span key={item}>{item}</span>
            ))}
          </div>
        </section>

        <div className="app-rules-grid">
          {sections.map((section, index) => (
            <article key={section.key} className="app-rules-card">
              <div className="app-rules-card__head">
                <span className="app-rules-card__index" aria-hidden="true">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <div>
                  <h2 className="app-rules-card__title">{section.title}</h2>
                  {section.summary && (
                    <p className="app-rules-card__summary">{section.summary}</p>
                  )}
                </div>
              </div>
              <ol className="app-rules-card__list">
                {section.data.map((item) => (
                  <li key={item.point} className="app-rules-card__item">
                    {item.text}
                  </li>
                ))}
              </ol>
            </article>
          ))}
        </div>

        {(footerLinks.length > 0 || footerNote) && (
          <footer className="app-rules-footer">
            {footerLinks.length > 0 && (
              <div className="app-rules-footer__links">
                {footerLinks.map((link) => (
                  <Link
                    key={link.href}
                    to={link.href}
                    className="app-rules-footer__link"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            )}
            {footerNote && (
              <p className="app-rules-footer__note">{footerNote}</p>
            )}
          </footer>
        )}
      </div>
    </AppPageShell>
  );

  if (!standalone) {
    return page;
  }

  return (
    <div className="app-legal-shell">
      <div className="app-main app-main--standalone">{page}</div>
    </div>
  );
}
